
const size = {
  mobile: '576px',
  tablet: '768px',
  laptop: '992px',
  desktop: '1200px'
}

export const device = {
  mobile: `(min-width: ${size.mobile})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  desktop: `(min-width: ${size.desktop})`,
}

// colors
export const autofillColor = "rgb(250, 255, 189)";
export const autofillColorSelected = "rgb(232, 240, 254)";
export const baseFontColor = "#090A0FDE"; //"#323232"
export const baseFontColorSemiTransparent = "rgba(50,50,50,0.6)";
export const baseFontColorTransparent = "rgba(50,50,50,0.1)";
export const black = "#323232";
export const blue = "rgb(33,18,94)";
export const blueDark = "#190c4e";
export const blueLight = "#513CA3";
export const blueOverlay = `rgba(33,18,94,0.1)`;
export const blueOverlayDark = `rgba(33,18,94,0.2)`;
export const gray = "#7d7d7d";
export const grayMedium = "#c4c4c4";
export const grayDark = "#323232";
export const grayLight = "#f1f5f5";
export const green = "#3ed256";
export const overlayColor = "rgba(199, 207, 207, 0.8)";
export const rose = "#c22d74";
export const turquoise = "#13bebb";
export const turquoiseDark = "#06a09e";
export const turquoiseLight = "rgba(6, 132, 123, 0.25)";
export const turquoiseTransparent = "rgba(6, 132, 123, 0.1)";
export const white = "#fff";
export const tabelGray = "#eaeaea";
export const darkGreen = "#06847B";
export const grayBackground = "f8f8f8";
export const coralOrange = "#ff6908";
export const cherryMagenta = "#fd346a";
export const magenta = "#e01d6c";
export const purple = "#7b406e";

// theme colors
export const theme = {
  activeMenuOption: darkGreen,
  autofill: autofillColor,
  autofillSelected: autofillColorSelected,
  baseFont: baseFontColor,
  baseFontColorSemiTransparent,
  baseFontColorTransparent,
  dark: black,
  disabled: gray,
  divider: grayLight,
  dividerDark: grayMedium,
  error: rose,
  grayBackground: grayBackground,
  hoverLightBackground: turquoiseLight,
  light: grayLight,
  lightFont: gray,
  listAttributeName: baseFontColorSemiTransparent,
  listBullet: darkGreen,
  overlay: overlayColor,
  primary: cherryMagenta,
  primaryDark: cherryMagenta,
  primaryLight: turquoiseLight,
  primaryTransparent: turquoiseTransparent,
  secondary: blue,
  secondaryDark: blueDark,
  secondaryLight: blueLight,
  secondaryOverlay: blueOverlay,
  secondaryOverlayDark: blueOverlayDark,
  success: green,
  tabTitle: darkGreen,
  tableDivider: tabelGray,
  tabsBorder: baseFontColorTransparent,
  thumbnailBorder: darkGreen,
  white,
};

// typography
export const baseFontFamily = "Poppins";
export const baseFontSize = "1rem"; // 16px
export const baseLineHeight = "1.25rem"; // 20px
export const boldFontWeight = 600;
export const extraBoldFontWeight = 800;
export const h1FontSize = "4rem"; // 64px
export const h2FontSize = "3rem"; // 48px
export const h1LineHeight = 1;
export const h3FontSize = "1.5rem"; // 24px
export const h4FontSize = "1.125rem"; // 18px
export const labelFontSize = "0.75rem"; // 12px
export const smallFontSize = "0.875rem"; // 14px
export const ultraBigFont = "6rem"; // 96px

// spacing
export const spacer = 1; // rem
export const fieldSpacer = "1.875rem";

// breakpoints
export const xxxLargeScreen = 1920;
export const xxLargeScreen = 1600;
export const xLargeScreen = 1280;
export const largeScreen = 992;
export const mediumScreen = 720;
export const smallScreen = 540;

export const getMstiTypeColor = (type: string) => {
  var colors = {
    o: {
      primary: "#FDDD56",
      background: "#FDDD56",
      chip: "#FDDD56",
    },
    m: {
      primary: "#FDDD56",
      background: "#FDDD56",
      chip: "#FDDD56",
    },
    c: {
      primary: "#FDDD56",
      background: "#FDDD56",
      chip: "#FDDD56",
    },
    d: {
      primary: "#FFA455",
      background: "#FFA455",
      chip: "#FFA455",
    },
    s: {
      primary: "#FF856F",
      background: "#FF856F",
      chip: "#FF856F",
    },
    r: {
      primary: "#79BCFF",
      background: "#79BCFF",
      chip: "#79BCFF",
    },
    a: {
      primary: "#FA6789",
      background: "#FA6789",
      chip: "#FA6789",
    },
    p: {
      primary: "#C48C0F",
      background: "#C48C0F",
      chip: "#C48C0F",
    },
    n: {
      primary: "#B4CEFF",
      background: "#B4CEFF",
      chip: "#B4CEFF",
    },
    f: {
      primary: "#B4DCFF",
      background: "#B4DCFF",
      chip: "#B4DCFF",
    },
    w: {
      primary: "#CFFD84",
      background: "#CFFD84",
      chip: "#CFFD84",
    },
    e: {
      primary: "#CFFD84",
      background: "#CFFD84",
      chip: "#CFFD84",
    },
    t: {
      primary: "#B4F6FF",
      background: "#B4F6FF",
      chip: "#B4F6FF",
    },
    unknown: {
      primary: "#8B8B8B",
      background: "#E4E4E4",
      chip: "#C7C7C7",
    },
    "": {
      primary: "#8B8B8B",
      background: "#E4E4E4",
      chip: "#C7C7C7",
    },
  };
  return colors[type];
};

export const getMstiTypeValue = (type: string) => {
  var typeMap = {
    o: "Oily",
    m: "Moisture-Deficient Oily",
    c: "Combination",
    d: "Dry",
    s: "Sensitive",
    r: "Resistant",
    a: "Acne",
    p: "Pigmented",
    n: "Non-Pigmented",
    f: "Free of Acne",
    w: "Wrinkled",
    e: "Expression Lines",
    t: "Tight",
  };
  return typeMap[type];
};
